"use client";

import { z } from "zod";

export type ScanQRModalSchemaType = z.infer<typeof scanQRModalSchema>;

export const scanQRModalSchema = z.object({
  qrValue: z.string().min(1, { message: "Required" }),
});
